var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUovaBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.14 7.5C23.19 7.5 30.89 15.83 30.89 28.18C30.89 35.98 27.48 42.5 18.69 42.5H18.06C9.26998 42.5 5.85999 35.98 5.85999 28.18C5.85999 15.83 13.56 7.5 17.61 7.5H19.15H19.14Z",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.39 13.17C34.26 11.03 37.91 10.59 39.63 11.57L40.84 12.27C44.04 14.1 46.3499 24.16 40.7599 33.91C38.1999 38.37 34.54 41.49 30.08 41.36",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUovaBlack);
export default __webpack_public_path__ + "static/media/ic_uova_black.86b75778d37e555a67e9b8527c6e12e6.svg";
export { ForwardRef as ReactComponent };